import React, { Component } from 'react';
import Loading from '../../Loading.js'
import FormTable from '../../../Fields/FormTable.js';
import FormTableSelectFilter from '../../../Fields/FormTableSelectFilter.js';
import FormDatePickerSimple from '../../../Fields/FormDatePickerSimple.js';
import ControlCv from './ControlCv.js';
import { getListCandidates } from '../../../Api/ExtranetActions.js'
import { getTranslation } from '../../../Utilities/GetTranslation.js'
import { getJsonDate, getDateString } from '../../../Utilities/JsonFunctions.js';
import { getFaseText, isFilterDate } from '../../../Utilities/SnsExtranetFunctions.js';

declare var globalSns;
declare var globalExtranet;
declare var $;

class ExtranetCandidates extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.onNavigate = this.onNavigate.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    loadData() {
        getListCandidates(globalSns.languageId, globalExtranet.showOpenOnly, (data) => {
            this.setState({
                listcandidates: data
            });
        });
    }

    onNavigate(id, title, type) {
        this.props.onNavigate(type, id, title);
    }    

    render() {
        if (this.state.listcandidates == null) {
            return (
                <Loading/>
            );
        }

        var columns = [
            {   Header: "",
                accessor: "id",             
                maxWidth: 25,   
                filterable: false,
                Pivot: row => {
                    if (row.subRows.length > 1) {
                        return (
                            <div className={"rt-expander " + (row.isExpanded && "-open")}>
                                &bull;
                            </div>
                        );
                    } else {
                        return null;
                    }
                  }
            },
            {
                Header: getTranslation("sns.general.name"),
                accessor: "name",
                minWidth: 150,
                aggregate: (values, rows) => values[0],
                Cell: row => {
                    if (row.level === 0) {
                        return <a onClick={(e) => this.props.onNavigate("extranetCandidatesFiche", row.subRows[0]._original.id, row.subRows[0]._original.firstName + " " + row.subRows[0]._original.name)}>{row.value}</a>
                    } else {
                        return null;
                    }
                }
            },
            {
                Header: getTranslation("sns.general.firstname"),
                accessor: "firstName",
                minWidth: 150,
                aggregate: (values, rows) => values[0],
                Cell: row => {
                    if (row.level === 0) {
                        return <a onClick={(e) => this.props.onNavigate("extranetCandidatesFiche", row.subRows[0]._original.id, row.subRows[0]._original.firstName + " " + row.subRows[0]._original.name)}>{row.value}</a>
                    } else {
                        return null;
                    }
                }
            },
            {
                Header: getTranslation("sns.general.extranet.entrydate"),
                accessor: "entryDate",
                width: 125,
                aggregate: (values, rows) => values[0],
                filterMethod: (filter, row) => {
                    return isFilterDate(filter.value, row[filter.id]);
                },                
                Filter: ({filter, onChange}) => {
                    return (
                        <FormDatePickerSimple onChange={event => onChange(event.target.value)} />
                    );
                },                
                Cell: row => {
                    if (row.level === 0) {
                        return <span>{getDateString(getJsonDate(row.value))}</span>
                    } else {
                        return null;
                    }
                }
            },
            {
                Header: getTranslation("sns.general.extranet.projects"),
                accessor: "project",
                minWidth: 300,
                sortable: false,
                filterMethod: (filter, row) => {
                    const id = filter.pivotId || filter.id;
                    if (row[id] !== null) {
                        if(row[id] === undefined)
                            return true;
                        
                        return  row[id].toString().toLowerCase() === filter.value.toString().toLowerCase();
                    }
                },
                Aggregated: row => {
                    return <a title={row.subRows[0].project} onClick={(e) => this.onNavigate(row.row._subRows[0]._original.projectId, row.row._subRows[0]._original.project, "extranetProjectsFiche")}>{row.subRows[0].project}</a>
                },
                Cell: row => {
                    return <a title={row.row.project} onClick={(e) => this.onNavigate(row.row._original.projectId, row.row._original.project, "extranetProjectsFiche")}>{row.row.project}</a>
                },
                Filter: ({filter, onChange}) => {
                    return (<FormTableSelectFilter filter={filter} onChange={onChange} data={this.state.listcandidates} accessor="project" />);
                } 
            },
            {
                Header: getTranslation("sns.general.extranet.fase"),
                accessor: "projectFase",
                width: 150,
                sortable: false,
                Aggregated: row => {
                    return <span className={"projectStatus" + row.row._subRows[0]._original.projectStatus}>{getFaseText(row.subRows[0]._original.projectFase)}</span>;
                },
                Cell: row => {
                    return <span className={"projectStatus" + row.row._original.projectStatus}>{getFaseText(row.row._original.projectFase)}</span>;
                },
                Filter: ({filter, onChange}) => {
                    return (
                        <div className="select-wrapper">
                            <select
                                onChange={event => onChange(event.target.value)}
                                value={filter ? filter.value : ""}>
                                <option value=""></option>
                                <option value="0">{getFaseText(0)}</option>
                                <option value="1">{getFaseText(1)}</option>
                                <option value="2">{getFaseText(2)}</option>
                                <option value="3">{getFaseText(3)}</option>
                                <option value="4">{getFaseText(4)}</option>
                                <option value="5">{getFaseText(5)}</option>
                                <option value="6">{getFaseText(6)}</option>
                                <option value="7">{getFaseText(7)}</option>
                                <option value="8">{getFaseText(8)}</option>
                                <option value="9">{getFaseText(9)}</option>
                            </select>
                        </div>
                    );
                }
            },
            {
                Header: getTranslation("sns.general.extranet.onlinecv"),
                accessor: "showOnlineCv",
                width: 125,
                filterable: false,
                sortable: false,
                Aggregated: row => {
                    if (!row.row._subRows[0].showOnlineCv) {
                        return "";
                    }
                    return <ControlCv className="text-center" candidateId={row.row._subRows[0]._original.id} jobId={row.row._subRows[0]._original.projectId} />;
                },
                Cell: row => {
                    if (!row.row.showOnlineCv) {
                        return "";
                    }
                    return <ControlCv className="text-center" candidateId={row.row._original.id} jobId={row.row._original.projectId} />;
                }
            },
            {
                Header: getTranslation("sns.general.extranet.documents"),
                accessor: "nrDocuments",
                width: 125,
                aggregate: (values, rows) => values[0],
                filterable: false,
                Cell: row => {
                    if (row.level === 0) {
                        return <a className="subcatlink" onClick={(e) => this.onNavigate(row.subRows[0]._original.id, row.subRows[0]._original.firstName + " " + row.subRows[0]._original.name, "extranetCandidatesDocuments")}><span className="alignnumeric">{row.value}</span> <i className="fa fa-paperclip" aria-hidden="true"></i></a>
                    } else {
                        return null;
                    }
                }
            },
            {
                Header: getTranslation("sns.general.extranet.messages"),
                accessor: "nrMessages",
                width: 125,
                aggregate: (values, rows) => values[0],
                filterable: false,
                Cell: row => {
                    if (row.level === 0) {
                        return <a className="subcatlink" onClick={(e) => this.onNavigate(row.subRows[0]._original.id, row.subRows[0]._original.firstName + " " + row.subRows[0]._original.name, "extranetCandidatesMessages")}><span className="alignnumeric">{row.value}</span> <i className="fa fa-envelope-o" aria-hidden="true"></i></a>
                    } else {
                        return null;
                    }
                }
            }
        ]

        return (
            <div className="container-fluid">
                <div className="row">
                    <FormTable 
                        data={
                            this.state.listcandidates                                        
                        }
                        columns={columns}
                        filterable={true} 
                        pivotBy={["id"]}
                        defaultSorted={[{id:"entryDate", desc: false}]}
                        />                                
                </div>
            </div>
        );
    }
}

export default ExtranetCandidates;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetCandidates.js